import beforeNextTick from './beforeNextTick';

const defaultLifecycleFn = (node, dispatch, next) => next();
const defaultAsyncLifecycleFn = (node, dispatch, next) =>
	beforeNextTick(() => defaultLifecycleFn(node, dispatch, next));

export default function createLifecycleFunctions(
	rendererOnConnect,
	rendererOnDisconnect,
	shouldRunAsync
) {
	if (shouldRunAsync && !rendererOnConnect) {
		// only the legacy react renderer should match this case
		return {
			onConnect: defaultAsyncLifecycleFn,
			onDisconnect: rendererOnDisconnect || defaultLifecycleFn
		};
	}

	return {
		onConnect: rendererOnConnect || defaultAsyncLifecycleFn,
		onDisconnect: rendererOnDisconnect || defaultLifecycleFn
	};
}
